// src/modules/app-views/_apps/appmulti/coupons/pages/Document/decorators/request.js
// Normalize the code on save (uppercase/trim); backend request decorator also guards.
const decorateRequest = ctx => {
  const { data, allValues } = ctx;
  if (!data) return data;
  const transformed = { ...data };
  const code = transformed.name ?? allValues?.name;
  if (typeof code === 'string') transformed.name = code.toUpperCase().trim();
  if (!transformed.type) transformed.type = allValues?.type || 'percentage';
  return transformed;
};

export default decorateRequest;
